function resize() {
  this.logger.log(`resize ${this.currentScene} scene`);
}

export { resize };
